import { render } from "./ChannelSubscribe.vue?vue&type=template&id=54e1cb52"
import script from "./ChannelSubscribe.vue?vue&type=script&lang=ts"
export * from "./ChannelSubscribe.vue?vue&type=script&lang=ts"
script.render = render

export default script